import React, { FunctionComponent } from "react";
import BodyText from "../typography/BodyText";
import { TitleHeading } from "../typography/TitleHeading";

type ImageTextSectionProps = {
  tag: string;
  title: JSX.Element | string;
  text?: string | React.ReactNode;
  image: string;
  theme?: "dark" | "white" | "gray";
  imagePosition?: string;
};

const ImageTextSection: FunctionComponent<ImageTextSectionProps> = ({
  tag,
  title,
  text,
  children,
  image,
  theme,
  imagePosition = "object-center",
}) => {
  return (
    <div className="relative mb-24">
      <div
        className={`hidden xl:block absolute ${
          theme === "dark"
            ? "bg-gray-900"
            : theme === "gray"
              ? "bg-gray-100 dark:bg-gray-900"
              : ""
        } h-24 top-0 left-0 right-0 `}
      />
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-16 container px-5 xl:px-12 mx-auto">
        <div className="hidden xl:block  border-8 border-white rounded-3xl z-20 bg-white dark:border-gray-800 dark:bg-gray-800 overflow-hidden">
          <img
            src={image}
            className={`h-full  object-cover ${imagePosition} shadow-lg`}
          />
        </div>
        <div className="mt-24 xl:mt-48 xl:pb-24">
          <TitleHeading tag={tag} title={title} />
          <BodyText className="text-justify mt-6" mb="6">
            {text}
          </BodyText>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ImageTextSection;
